import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Widget from "./widget/Index";
import { BrowserRouter as Router } from "react-router-dom";
import "./services/Http";

const rootElement = document.getElementById("root");

declare global {
  interface Window {
    mykiotPreviewWebsite: any;
  }
}

ReactDOM.render(
  <React.StrictMode>
    <Router>
      {(localStorage && localStorage.getItem("isWidgetMykiot") && <Widget />) || <App />}
    </Router>
  </React.StrictMode>,
  rootElement
);
